export default "__VITE_ASSET__KQeorNIO__"